import { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Link } from 'react-router-dom';

// ============================================================
// SVG ICONS ANIMADOS PREMIUM — ESTILO HUD GT RACE
// ============================================================

const CookieIcon = ({ className = "w-5 h-5" }) => (
  <svg className={className} viewBox="0 0 48 48" fill="none">
    <defs>
      <linearGradient id="cookieGold" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#D4AF37" />
        <stop offset="100%" stopColor="#F5D76E" />
      </linearGradient>
    </defs>
    {/* Círculo base */}
    <circle cx="24" cy="24" r="18" stroke="url(#cookieGold)" strokeWidth="1.5" fill="none" opacity="0.4" />
    <circle cx="24" cy="24" r="15" fill="url(#cookieGold)" opacity="0.1" />
    {/* Mordisco */}
    <path d="M38 16 C35 12 30 10 28 14 C32 14 34 18 38 16 Z" fill="url(#cookieGold)" opacity="0.6" />
    {/* Chispas del mordisco */}
    <circle cx="38" cy="16" r="2" fill="#D4AF37" opacity="0.8">
      <animate attributeName="opacity" values="0.8;0.2;0.8" dur="2s" repeatCount="indefinite" />
    </circle>
    {/* Chips de chocolate */}
    <circle cx="18" cy="20" r="2.5" fill="#D4AF37" opacity="0.7" />
    <circle cx="28" cy="18" r="2" fill="#D4AF37" opacity="0.6" />
    <circle cx="22" cy="30" r="2.5" fill="#D4AF37" opacity="0.7" />
    <circle cx="31" cy="28" r="2" fill="#D4AF37" opacity="0.6" />
    <circle cx="16" cy="28" r="1.5" fill="#D4AF37" opacity="0.5" />
    {/* HUD corners */}
    <path d="M6 12 L6 8 L10 8" stroke="#D4AF37" strokeWidth="1" opacity="0.4" fill="none" />
    <path d="M42 12 L42 8 L38 8" stroke="#D4AF37" strokeWidth="1" opacity="0.4" fill="none" />
  </svg>
);

const ShieldIcon = ({ className = "w-5 h-5" }) => (
  <svg className={className} viewBox="0 0 48 48" fill="none">
    <defs>
      <linearGradient id="shieldGold" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#D4AF37" />
        <stop offset="100%" stopColor="#F5D76E" />
      </linearGradient>
    </defs>
    <path d="M24 6 L40 12 L40 26 C40 34 32 41 24 44 C16 41 8 34 8 26 L8 12 Z"
      stroke="url(#shieldGold)" strokeWidth="1.5" fill="url(#shieldGold)" fillOpacity="0.1" />
    <path d="M16 24 L21 29 L32 19" stroke="#D4AF37" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
    <circle cx="24" cy="6" r="2" fill="#D4AF37" opacity="0.8">
      <animate attributeName="opacity" values="0.8;0.3;0.8" dur="2s" repeatCount="indefinite" />
    </circle>
  </svg>
);

const LockIcon = ({ className = "w-4 h-4" }) => (
  <svg className={className} viewBox="0 0 48 48" fill="none">
    <defs>
      <linearGradient id="lockGold" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#D4AF37" />
        <stop offset="100%" stopColor="#F5D76E" />
      </linearGradient>
    </defs>
    <rect x="10" y="22" width="28" height="20" rx="4" stroke="url(#lockGold)" strokeWidth="1.5" fill="none" />
    <path d="M16 22 L16 16 C16 10 32 10 32 16 L32 22" stroke="url(#lockGold)" strokeWidth="1.5" fill="none" strokeLinecap="round" />
    <circle cx="24" cy="32" r="3" fill="#D4AF37" opacity="0.8" />
    <rect x="22.5" y="32" width="3" height="5" rx="1" fill="#D4AF37" opacity="0.6" />
  </svg>
);

const AnalyticsIcon = ({ className = "w-4 h-4" }) => (
  <svg className={className} viewBox="0 0 48 48" fill="none">
    <defs>
      <linearGradient id="analyticsGold" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#D4AF37" />
        <stop offset="100%" stopColor="#F5D76E" />
      </linearGradient>
    </defs>
    <path d="M6 38 L16 24 L24 30 L34 16 L42 20" stroke="url(#analyticsGold)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <circle cx="42" cy="20" r="3" fill="#D4AF37">
      <animate attributeName="opacity" values="1;0.3;1" dur="1.5s" repeatCount="indefinite" />
    </circle>
    <path d="M6 42 L42 42" stroke="#D4AF37" strokeWidth="1" opacity="0.3" />
    <path d="M6 38 L6 8" stroke="#D4AF37" strokeWidth="1" opacity="0.3" />
  </svg>
);

const FunctionalIcon = ({ className = "w-4 h-4" }) => (
  <svg className={className} viewBox="0 0 48 48" fill="none">
    <defs>
      <linearGradient id="funcGold" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#D4AF37" />
        <stop offset="100%" stopColor="#F5D76E" />
      </linearGradient>
    </defs>
    <circle cx="24" cy="24" r="6" stroke="url(#funcGold)" strokeWidth="1.5" fill="none" />
    <path d="M24 8 L24 12 M24 36 L24 40 M8 24 L12 24 M36 24 L40 24
             M12.7 12.7 L15.5 15.5 M32.5 32.5 L35.3 35.3
             M35.3 12.7 L32.5 15.5 M15.5 32.5 L12.7 35.3"
      stroke="#D4AF37" strokeWidth="2" strokeLinecap="round">
      <animateTransform attributeName="transform" type="rotate" from="0 24 24" to="360 24 24" dur="10s" repeatCount="indefinite" />
    </path>
  </svg>
);

const MarketingIcon = ({ className = "w-4 h-4" }) => (
  <svg className={className} viewBox="0 0 48 48" fill="none">
    <defs>
      <linearGradient id="mktGold" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#D4AF37" />
        <stop offset="100%" stopColor="#F5D76E" />
      </linearGradient>
    </defs>
    <path d="M8 30 L8 18 L24 10 L24 38 Z" stroke="url(#mktGold)" strokeWidth="1.5" fill="url(#mktGold)" fillOpacity="0.15" />
    <path d="M24 14 L38 18 L38 30 L24 34 Z" stroke="url(#mktGold)" strokeWidth="1.5" fill="url(#mktGold)" fillOpacity="0.1" />
    <path d="M8 30 L14 30 L14 38 L8 38 Z" stroke="#D4AF37" strokeWidth="1.2" fill="none" />
    <circle cx="38" cy="24" r="2" fill="#D4AF37">
      <animate attributeName="r" values="2;3;2" dur="1.5s" repeatCount="indefinite" />
    </circle>
  </svg>
);

const NecessaryIcon = ({ className = "w-4 h-4" }) => (
  <svg className={className} viewBox="0 0 48 48" fill="none">
    <defs>
      <linearGradient id="necGold" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#D4AF37" />
        <stop offset="100%" stopColor="#F5D76E" />
      </linearGradient>
    </defs>
    <circle cx="24" cy="24" r="18" stroke="url(#necGold)" strokeWidth="1.5" fill="none" opacity="0.4" />
    <path d="M14 24 L21 31 L34 17" stroke="#D4AF37" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const CloseIcon = ({ className = "w-5 h-5" }) => (
  <svg className={className} viewBox="0 0 48 48" fill="none">
    <circle cx="24" cy="24" r="18" stroke="currentColor" strokeWidth="1.5" opacity="0.3" />
    <path d="M16 16 L32 32 M32 16 L16 32" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

const SettingsIcon = ({ className = "w-3.5 h-3.5" }) => (
  <svg className={className} viewBox="0 0 48 48" fill="none">
    <defs>
      <linearGradient id="setGold" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#D4AF37" />
        <stop offset="100%" stopColor="#F5D76E" />
      </linearGradient>
    </defs>
    <circle cx="24" cy="24" r="5" stroke="url(#setGold)" strokeWidth="1.5" fill="none" />
    <path d="M24 8v4M24 36v4M8 24h4M36 24h4M13 13l3 3M32 32l3 3M35 13l-3 3M16 32l-3 3"
      stroke="#D4AF37" strokeWidth="1.8" strokeLinecap="round" />
  </svg>
);

// ============================================================
// HOOK CONSENTIMIENTO
// ============================================================
export const useCookieConsent = () => {
  const getConsent = () => {
    try {
      const stored = localStorage.getItem('gt_cookie_consent');
      return stored ? JSON.parse(stored) : null;
    } catch { return null; }
  };

  const [consent, setConsent] = useState(getConsent);

  const saveConsent = (preferences) => {
    const data = { ...preferences, timestamp: new Date().toISOString(), version: '1.0' };
    localStorage.setItem('gt_cookie_consent', JSON.stringify(data));
    setConsent(data);

    if (typeof window !== 'undefined' && window.dataLayer) {
      window.dataLayer.push({
        event: 'cookie_consent_update',
        analytics_storage: preferences.analytics ? 'granted' : 'denied',
        ad_storage: preferences.marketing ? 'granted' : 'denied',
        functionality_storage: preferences.functional ? 'granted' : 'denied',
      });
    }
  };

  return { consent, saveConsent, hasConsented: consent !== null };
};

// ============================================================
// COMPONENTE PRINCIPAL
// ============================================================
const CookieBanner = () => {
  const { saveConsent, hasConsented } = useCookieConsent();
  const [visible, setVisible] = useState(false);
  const [showDetails, setShowDetails] = useState(false);
  const [preferences, setPreferences] = useState({
    necessary: true,
    functional: false,
    analytics: false,
    marketing: false,
  });

  useEffect(() => {
    if (!hasConsented) {
      const timer = setTimeout(() => setVisible(true), 1500);
      return () => clearTimeout(timer);
    }
  }, [hasConsented]);

  const handleAcceptAll = () => {
    saveConsent({ necessary: true, functional: true, analytics: true, marketing: true });
    setVisible(false);
  };

  const handleRejectAll = () => {
    saveConsent({ necessary: true, functional: false, analytics: false, marketing: false });
    setVisible(false);
  };

  const handleSavePreferences = () => {
    saveConsent(preferences);
    setVisible(false);
  };

  const toggle = (key) => {
    if (key === 'necessary') return;
    setPreferences(prev => ({ ...prev, [key]: !prev[key] }));
  };

  if (!visible) return null;

  const cookieTypes = [
    {
      key: 'necessary',
      title: 'Cookies necesarias',
      desc: 'Imprescindibles para el funcionamiento de la web. Incluyen sesión de usuario, seguridad y preferencias básicas.',
      locked: true,
      Icon: NecessaryIcon,
    },
    {
      key: 'functional',
      title: 'Cookies funcionales',
      desc: 'Permiten recordar tus preferencias como idioma y región para ofrecerte una experiencia personalizada.',
      locked: false,
      Icon: FunctionalIcon,
    },
    {
      key: 'analytics',
      title: 'Cookies analíticas',
      desc: 'Nos ayudan a entender cómo interactúas con la web (Google Analytics, GTM). Los datos son anónimos.',
      locked: false,
      Icon: AnalyticsIcon,
    },
    {
      key: 'marketing',
      title: 'Cookies de marketing',
      desc: 'Usadas para mostrarte anuncios relevantes en Google Ads y redes sociales según tus intereses.',
      locked: false,
      Icon: MarketingIcon,
    },
  ];

  return (
    <AnimatePresence>
      {visible && (
        <>
          {showDetails && (
            <motion.div
              initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
              className="fixed inset-0 bg-black/60 backdrop-blur-sm z-[998]"
              onClick={() => setShowDetails(false)}
            />
          )}

          <motion.div
            initial={{ opacity: 0, y: 100 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 100 }}
            transition={{ duration: 0.5, ease: [0.23, 1, 0.32, 1] }}
            className="fixed bottom-0 left-0 right-0 z-[999] p-3 sm:p-4"
          >
            <div className="max-w-6xl mx-auto">
              <div className="bg-gt-gray-dark/95 backdrop-blur-2xl rounded-2xl border border-white/10 shadow-2xl shadow-black/50 overflow-hidden">

                {/* Línea dorada superior animada */}
                <div className="h-0.5 bg-gradient-to-r from-transparent via-gt-gold to-transparent">
                  <motion.div
                    className="h-full w-1/3 bg-gt-gold/60 blur-sm"
                    animate={{ x: ['0%', '300%'] }}
                    transition={{ duration: 3, repeat: Infinity, ease: 'linear' }}
                  />
                </div>

                {/* ── VISTA SIMPLE ─────────────────────────── */}
                {!showDetails && (
                  <div className="p-4 sm:p-5 flex flex-col sm:flex-row items-start sm:items-center gap-4">

                    {/* Icono + texto */}
                    <div className="flex items-start gap-3 flex-1">
                      <motion.div
                        animate={{ rotate: [0, -5, 5, 0] }}
                        transition={{ duration: 4, repeat: Infinity, ease: 'easeInOut' }}
                        className="flex-shrink-0 w-10 h-10 bg-gt-gold/10 rounded-xl flex items-center justify-center border border-gt-gold/20"
                      >
                        <CookieIcon className="w-5 h-5" />
                      </motion.div>
                      <div>
                        <p className="text-white font-semibold text-sm mb-0.5 flex items-center gap-2">
                          <ShieldIcon className="w-4 h-4" />
                          Tu privacidad nos importa
                        </p>
                        <p className="text-gray-400 text-xs leading-relaxed max-w-xl">
                          Utilizamos cookies propias y de terceros para mejorar tu experiencia, analizar el tráfico
                          y personalizar el contenido. Puedes aceptar todas, rechazar las opcionales o{' '}
                          <button onClick={() => setShowDetails(true)}
                            className="text-gt-gold hover:underline font-medium">
                            personalizar tus preferencias
                          </button>.
                          Más info en nuestra{' '}
                          <Link to="/privacy" className="text-gt-gold hover:underline font-medium">
                            Política de Privacidad
                          </Link>.
                        </p>
                      </div>
                    </div>

                    {/* Botones */}
                    <div className="flex items-center gap-2 flex-shrink-0 w-full sm:w-auto">
                      <motion.button
                        whileHover={{ scale: 1.03 }} whileTap={{ scale: 0.97 }}
                        onClick={handleRejectAll}
                        className="flex-1 sm:flex-none px-4 py-2.5 text-xs font-semibold text-gray-400 hover:text-white bg-white/5 hover:bg-white/10 border border-white/10 rounded-xl transition-all"
                      >
                        Solo necesarias
                      </motion.button>
                      <motion.button
                        whileHover={{ scale: 1.03 }} whileTap={{ scale: 0.97 }}
                        onClick={() => setShowDetails(true)}
                        className="flex-1 sm:flex-none flex items-center justify-center gap-1.5 px-4 py-2.5 text-xs font-semibold text-gt-gold bg-gt-gold/10 hover:bg-gt-gold/20 border border-gt-gold/30 rounded-xl transition-all"
                      >
                        <SettingsIcon className="w-3.5 h-3.5" />
                        Personalizar
                      </motion.button>
                      <motion.button
                        whileHover={{ scale: 1.03 }} whileTap={{ scale: 0.97 }}
                        onClick={handleAcceptAll}
                        className="flex-1 sm:flex-none flex items-center justify-center gap-1.5 px-5 py-2.5 text-xs font-bold text-black bg-gradient-to-r from-gt-gold to-yellow-600 hover:shadow-lg hover:shadow-gt-gold/30 rounded-xl transition-all"
                      >
                        <ShieldIcon className="w-4 h-4" />
                        Aceptar todas
                      </motion.button>
                    </div>
                  </div>
                )}

                {/* ── VISTA DETALLADA ───────────────────────── */}
                {showDetails && (
                  <motion.div
                    initial={{ opacity: 0, height: 0 }}
                    animate={{ opacity: 1, height: 'auto' }}
                    className="p-4 sm:p-6"
                  >
                    <div className="flex items-center justify-between mb-4">
                      <h3 className="text-white font-march font-bold text-lg flex items-center gap-2">
                        <CookieIcon className="w-5 h-5" />
                        Configuración de cookies
                      </h3>
                      <motion.button
                        whileHover={{ scale: 1.1 }} whileTap={{ scale: 0.9 }}
                        onClick={() => setShowDetails(false)}
                        className="text-gray-500 hover:text-white transition-colors"
                      >
                        <CloseIcon className="w-5 h-5" />
                      </motion.button>
                    </div>

                    <p className="text-gray-400 text-xs mb-5 leading-relaxed">
                      Selecciona qué tipos de cookies deseas permitir. Las cookies necesarias no se pueden
                      desactivar ya que son imprescindibles para el funcionamiento de la web.
                    </p>

                    {/* Toggle items */}
                    <div className="space-y-3 mb-6">
                      {cookieTypes.map(({ key, title, desc, locked, Icon }) => (
                        <motion.div
                          key={key}
                          whileHover={{ x: 2 }}
                          className="flex items-start gap-3 sm:gap-4 p-3 sm:p-4 bg-white/5 rounded-xl border border-white/10 hover:border-gt-gold/20 transition-all"
                        >
                          {/* Icono categoría */}
                          <div className="flex-shrink-0 w-8 h-8 bg-gt-gold/10 rounded-lg flex items-center justify-center border border-gt-gold/20 mt-0.5">
                            <Icon className="w-4 h-4 text-gt-gold" />
                          </div>

                          <div className="flex-1">
                            <div className="flex items-center gap-2 mb-1">
                              <p className="text-white font-semibold text-sm">{title}</p>
                              {locked && (
                                <span className="flex items-center gap-1 px-2 py-0.5 bg-gt-gold/20 text-gt-gold text-[10px] font-bold rounded-full border border-gt-gold/30">
                                  <LockIcon className="w-2.5 h-2.5" />
                                  Siempre activas
                                </span>
                              )}
                            </div>
                            <p className="text-gray-500 text-xs leading-relaxed">{desc}</p>
                          </div>

                          {/* Toggle switch */}
                          <motion.div
                            whileTap={{ scale: 0.95 }}
                            onClick={() => toggle(key)}
                            className={`relative flex-shrink-0 w-11 h-6 rounded-full transition-all duration-300 mt-1
                              ${locked ? 'bg-gt-gold cursor-not-allowed' : preferences[key] ? 'bg-gt-gold cursor-pointer' : 'bg-white/20 cursor-pointer'}`}
                          >
                            <motion.div
                              animate={{ x: preferences[key] || locked ? 20 : 2 }}
                              transition={{ type: 'spring', stiffness: 500, damping: 30 }}
                              className="absolute top-0.5 w-5 h-5 bg-white rounded-full shadow-md"
                            />
                          </motion.div>
                        </motion.div>
                      ))}
                    </div>

                    {/* Botones detalle */}
                    <div className="flex flex-col sm:flex-row gap-2">
                      <motion.button
                        whileHover={{ scale: 1.02 }} whileTap={{ scale: 0.98 }}
                        onClick={handleRejectAll}
                        className="flex-1 py-3 text-sm font-semibold text-gray-400 hover:text-white bg-white/5 hover:bg-white/10 border border-white/10 rounded-xl transition-all"
                      >
                        Solo necesarias
                      </motion.button>
                      <motion.button
                        whileHover={{ scale: 1.02 }} whileTap={{ scale: 0.98 }}
                        onClick={handleSavePreferences}
                        className="flex-1 flex items-center justify-center gap-2 py-3 text-sm font-semibold text-gt-gold bg-gt-gold/10 hover:bg-gt-gold/20 border border-gt-gold/30 rounded-xl transition-all"
                      >
                        <SettingsIcon className="w-4 h-4" />
                        Guardar preferencias
                      </motion.button>
                      <motion.button
                        whileHover={{ scale: 1.02 }} whileTap={{ scale: 0.98 }}
                        onClick={handleAcceptAll}
                        className="flex-1 flex items-center justify-center gap-2 py-3 text-sm font-bold text-black bg-gradient-to-r from-gt-gold to-yellow-600 hover:shadow-lg hover:shadow-gt-gold/30 rounded-xl transition-all"
                      >
                        <ShieldIcon className="w-4 h-4" />
                        Aceptar todas
                      </motion.button>
                    </div>

                    <p className="text-gray-600 text-[10px] text-center mt-3">
                      Puedes cambiar tus preferencias en cualquier momento desde nuestra{' '}
                      <Link to="/privacy" className="text-gt-gold hover:underline">Política de Privacidad</Link>.
                      · GT Race Marbella · RGPD / LOPD compliant
                    </p>
                  </motion.div>
                )}
              </div>
            </div>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
};

// ============================================================
// BOTÓN PARA REABRIR PREFERENCIAS (footer)
// ============================================================
export const CookieSettingsButton = () => {
  const reopen = () => {
    localStorage.removeItem('gt_cookie_consent');
    window.location.reload();
  };

  return (
    <motion.button
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
      onClick={reopen}
      className="flex items-center gap-1.5 text-gray-500 hover:text-gt-gold transition-colors text-xs"
    >
      <CookieIcon className="w-3.5 h-3.5" />
      Gestionar cookies
    </motion.button>
  );
};

export default CookieBanner;